import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6111">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6112">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6113">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6114">
            <ArrowLeft className="w-4 h-4" data-id="element-6115" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6116">NOIZA</div>
          <div className="w-20" data-id="element-6117" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6118">
        <div className="mb-12" data-id="element-6119">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6120">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6121" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6122">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6123">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6124">
          <section data-id="element-6125">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6126">
              <span className="text-[#006847]" data-id="element-6127">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6128">
              <p data-id="element-6129">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6130">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6131">
                <li data-id="element-6132">Haber leído íntegramente este documento</li>
                <li data-id="element-6133">Comprender su contenido en su totalidad</li>
                <li data-id="element-6134">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6135">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6136">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6137">
              <span className="text-[#006847]" data-id="element-6138">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6139">
              <p data-id="element-6140">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6141">
                <li data-id="element-6142">Software como servicio (SaaS)</li>
                <li data-id="element-6143">Marketplace digital gastronómico</li>
                <li data-id="element-6144">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6145">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6146">
                <li data-id="element-6147">Mostrar su menú digital</li>
                <li data-id="element-6148">Recibir pedidos de clientes</li>
                <li data-id="element-6149">Gestionar su operación interna</li>
                <li data-id="element-6150">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6151">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6152">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6153">
              <span className="text-[#006847]" data-id="element-6154">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6155">
              <p data-id="element-6156">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6157">
                <li data-id="element-6158">No es proveedor de alimentos</li>
                <li data-id="element-6159">No participa en la preparación de productos</li>
                <li data-id="element-6160">No manipula alimentos en ningún momento</li>
                <li data-id="element-6161">No realiza entregas ni logística</li>
                <li data-id="element-6162">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6163">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6164">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6165">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6166">
              <span className="text-[#006847]" data-id="element-6167">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6168">
              <p data-id="element-6169">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6170">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6171">
                <li data-id="element-6172">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6173">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6174">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6175">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6176">
                <li data-id="element-6177">Precios</li>
                <li data-id="element-6178">Menú</li>
                <li data-id="element-6179">Horarios</li>
                <li data-id="element-6180">Métodos de pago</li>
                <li data-id="element-6181">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6182">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6183">
              <span className="text-[#006847]" data-id="element-6184">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6185">
              <div data-id="element-6186">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6187">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6188">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6189">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6190">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6191">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6192">
                  <li data-id="element-6193">Calidad de los alimentos</li>
                  <li data-id="element-6194">Estado, frescura o preparación</li>
                  <li data-id="element-6195">Ingredientes utilizados</li>
                  <li data-id="element-6196">Contaminación cruzada</li>
                  <li data-id="element-6197">Problemas de higiene o salubridad</li>
                  <li data-id="element-6198">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6199">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6200">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6201">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6202">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6203">
                  <li data-id="element-6204">Retrasos en la entrega</li>
                  <li data-id="element-6205">Pérdida de pedidos</li>
                  <li data-id="element-6206">Entregas incompletas</li>
                  <li data-id="element-6207">Errores en dirección</li>
                  <li data-id="element-6208">Conducta de repartidores</li>
                  <li data-id="element-6209">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6210">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6211">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6212">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6213">
                  <li data-id="element-6214">Recepción de pagos</li>
                  <li data-id="element-6215">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6216">Manejo de efectivo</li>
                  <li data-id="element-6217">Confirmación de pagos</li>
                  <li data-id="element-6218">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6219">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6220">
                  <li data-id="element-6221">Pagos no recibidos</li>
                  <li data-id="element-6222">Comprobantes falsos</li>
                  <li data-id="element-6223">Errores en montos</li>
                  <li data-id="element-6224">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6225">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6226">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6227">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6228">
                  <li data-id="element-6229">Reclamos de clientes</li>
                  <li data-id="element-6230">Reembolsos</li>
                  <li data-id="element-6231">Cancelaciones</li>
                  <li data-id="element-6232">Disputas</li>
                  <li data-id="element-6233">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6234">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6235">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6236">
              <span className="text-[#006847]" data-id="element-6237">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6238">
              <p data-id="element-6239">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6240">
                <li data-id="element-6241">Responsable</li>
                <li data-id="element-6242">Legal</li>
                <li data-id="element-6243">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6244">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6245">
                <li data-id="element-6246">Publicar información falsa</li>
                <li data-id="element-6247">Manipular precios de forma engañosa</li>
                <li data-id="element-6248">Simular disponibilidad inexistente</li>
                <li data-id="element-6249">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6250">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6251">
              <span className="text-[#006847]" data-id="element-6252">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6253">
              <p data-id="element-6254">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6255">
                <li data-id="element-6256">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6257">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6258">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6259">
                <li data-id="element-6260">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6261">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6262">
                    <li data-id="element-6263">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6264">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6265">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6266">
              <span className="text-[#006847]" data-id="element-6267">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6268">
              <p data-id="element-6269">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6270">
                <li data-id="element-6271">Menú digital</li>
                <li data-id="element-6272">Gestión de pedidos</li>
                <li data-id="element-6273">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6274">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6275">
                  <p className="font-medium text-white mb-2" data-id="element-6276">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6277">
                    <li data-id="element-6278">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6279">
                  <p className="font-medium text-white mb-2" data-id="element-6280">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6281">
                    <li data-id="element-6282">Propiedad del software</li>
                    <li data-id="element-6283">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6284">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6285">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6286">
              <span className="text-[#006847]" data-id="element-6287">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6288">
              <p data-id="element-6289">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6290">
                <li data-id="element-6291">Disponibilidad continua</li>
                <li data-id="element-6292">Funcionamiento sin interrupciones</li>
                <li data-id="element-6293">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6294">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6295">
                <li data-id="element-6296">Fallas técnicas</li>
                <li data-id="element-6297">Actualizaciones</li>
                <li data-id="element-6298">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6299">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6300">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6301">
              <span className="text-[#006847]" data-id="element-6302">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6303">
              <p data-id="element-6304">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6305">
                <li data-id="element-6306">No está garantizada permanentemente</li>
                <li data-id="element-6307">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6308">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6309">
                <li data-id="element-6310">Destacar o no restaurantes</li>
                <li data-id="element-6311">Modificar posiciones</li>
                <li data-id="element-6312">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6313">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6314">
              <span className="text-[#006847]" data-id="element-6315">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6316">
              <p data-id="element-6317">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6318">
                <li data-id="element-6319">Cumplir con los pagos acordados</li>
                <li data-id="element-6320">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6321">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6322">
                <li data-id="element-6323">Suspender el servicio</li>
                <li data-id="element-6324">Limitar funcionalidades</li>
                <li data-id="element-6325">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6326">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6327">
              <span className="text-[#006847]" data-id="element-6328">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6329">
              <p data-id="element-6330">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6331">
                <li data-id="element-6332">Incumplimiento de términos</li>
                <li data-id="element-6333">Uso indebido</li>
                <li data-id="element-6334">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6335">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6336">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6337">
              <span className="text-[#006847]" data-id="element-6338">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6339">
              <p data-id="element-6340">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6341">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6342">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6343">
              <span className="text-[#006847]" data-id="element-6344">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6345">
              <p data-id="element-6346">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6347">
                <li data-id="element-6348">Pérdidas económicas</li>
                <li data-id="element-6349">Daños indirectos</li>
                <li data-id="element-6350">Lucro cesante</li>
                <li data-id="element-6351">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6352">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6353">
              <span className="text-[#006847]" data-id="element-6354">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6355">
              <p data-id="element-6356">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6357">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6358">
              <span className="text-[#006847]" data-id="element-6359">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6360">
              <p className="font-medium" data-id="element-6361">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6362">
                <li data-id="element-6363">Ha leído este documento completo</li>
                <li data-id="element-6364">Comprende su alcance</li>
                <li data-id="element-6365">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}